// extracted by mini-css-extract-plugin
export var applied = "discount-code-input-module--applied--Uq64g";
export var button = "discount-code-input-module--button--gc1Se";
export var discountCodeInput = "discount-code-input-module--discount-code-input--ZTpCW";
export var discountCodeInputWrapper = "discount-code-input-module--discount-code-input-wrapper--SjPbj";
export var input = "discount-code-input-module--input--ZmExd";
export var inputWrapper = "discount-code-input-module--input-wrapper--Qt2J8";
export var message = "discount-code-input-module--message--2BFI0";
export var outlined = "discount-code-input-module--outlined--P5WYc";